import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation smooth pour les dividers : width 0 à 100%
 */
function initDividerAnimation() {
  // Définir l'état initial pour tous les dividers animés
  document.querySelectorAll(".divider.animate-width, .divider.animate-width-scroll").forEach((el) => {
    gsap.set(el, {
      scaleX: 0,
      transformOrigin: "left center",
    });
  });

  // Animation immédiate
  document.querySelectorAll(".divider.animate-width").forEach((el) => {
    gsap.to(el, {
        scaleX: 1,
        duration: 1.2,
        ease: "power3.out",
      delay: 0.1, // Petit délai pour éviter le flash
    });
  });

  // Animation au scroll
  document.querySelectorAll(".divider.animate-width-scroll").forEach((el) => {
    gsap.to(el, {
        scaleX: 1,
        duration: 1.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          toggleActions: "play none none none",
        },
    });
  });
}

// Exposer la fonction globalement pour Barba.js
window.initDividerAnimation = initDividerAnimation;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initDividerAnimation);
} else {
  initDividerAnimation();
}

